import Api from "@/services/api";
import {
	LOAD_RC,
	CREATE_RC,
	EDIT_RC,
	REMOVE_RC,
	REMOVE_RCS,
	ADD_ALERT,
} from "@/store/_actiontypes";
import { SET_RC, ADD_RC, UPDATE_RC, DELETE_RC } from "@/store/_mutationtypes";

const state = {
	responsecodelist: [],
};

const actions = {
	[LOAD_RC]({ commit }) {
		Api.get("/rc").then((response) => {
			let item = response.data;
			commit(SET_RC, item);
		});
	},
	[CREATE_RC]({ commit, dispatch }, { item }) {
		return Api.post("/rc", {
			name: item.name,
			spdh: item.spdh,
			iso2byte: item.iso2byte,
			iso3byte: item.iso3byte,
			apacs: item.apacs,
			hostresponsetext: item.hostresponsetext,
			description: item.description,
		}).then((response) => {
			let item = response.data;
			commit(ADD_RC, item);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "RC added successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[EDIT_RC]({ commit, dispatch }, { item }) {
		return Api.put(`/rc/${item.id}`, item).then((response) => {
			let item = response.data;
			commit(UPDATE_RC, item);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "RC updaded successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_RC]({ commit, dispatch }, { id }) {
		Api.delete(`/rc/${id}`).then(() => {
			commit(DELETE_RC, id);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "RC deleted successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_RCS]({ commit, dispatch }, { ids }) {
		ids.forEach((id) => {
			Api.delete(`/rc/${id}`).then(() => {
				commit(DELETE_RC, id);
			});
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: `Successfully deleted ${ids.length} RCs`, color: "success" },
				{ root: true }
			);
		});
	},
};

const mutations = {
	[SET_RC](state, item) {
		state.responsecodelist = item;
	},
	[ADD_RC](state, item) {
		state.responsecodelist.push(item);
	},
	[UPDATE_RC](state, item) {
		let lVar = state.responsecodelist.find((h) => h.id == item.id);
		lVar.name = item.name;
		lVar.spdh = item.spdh;
		lVar.iso2byte = item.iso2byte;
		lVar.iso3byte = item.iso3byte;
		lVar.apacs = item.apacs;
		lVar.hostresponsetext = item.hostresponsetext;
		lVar.description = item.description;
	},
	[DELETE_RC](state, id) {
		state.responsecodelist = state.responsecodelist.filter((h) => h.id != id);
	},
};

export const responscodes = {
	namespaced: true,
	state,
	actions,
	mutations,
};
